import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/spencerrider.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import 'bootstrap/dist/css/bootstrap.css';
import Notifications from 'react-notify-toast';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import rootReducer from './reducer/index.js';
export const store = createStore(rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
ReactDOM.render(
        <Provider store={store}>
          <MuiThemeProvider>
              <div>
                <App />
                <Notifications />
              </div>
            </MuiThemeProvider>
        </Provider>
,document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js